export default function BeardItemCard({ item, isNew, onActionPress }) {

    if (item.isEmpty) {
        return <div className="push-item push-item__empty">
            <h3>{item.title}</h3>
            {item.text && <p>{item.text}</p>}
        </div>
    }

    let titleHtml = item.title.text,
        linkHref = null,
        linkAction = null;

    if (item.title.link) {
        linkHref = item.title.link.url ? item.title.link.url : '#';
        linkAction = item.title.link.action ? e => onActionPress(e, item, item.title.link.action) : null;
        // const link = <a href={linkHref} onClick={linkAction}>{notification.title.link.text}</a>;
        const link = <span className={'not_link'}>{item.title.link.text}</span>;
        titleHtml = titleHtml.split(item.title.link.replace);
        if (titleHtml.length > 0) titleHtml.splice(1, 0, link);
        titleHtml = <React.Fragment>
            {titleHtml[0]}{titleHtml[1]}{titleHtml[2]}{titleHtml[4]}
        </React.Fragment>
    }

    const linkItemBlock = () => {
        return <div>
            <div className="push-item__top">
                {isNew && <span className="push-item__new-indicator" />}
                {!!item.request_number && <div className="push-item__status-count">
                    {__('request.title')} <span>№{item.request_number}</span>
                </div>}
                {!!item.date && <div className="push-item__date">
                    {item.date}
                </div>}
            </div>
            <div className="push-item__status">
                <span>{titleHtml}</span>
            </div>
            {!!item.routes && item.routes.map((route, index) => {
                return <div key={index}
                    className={clsx({ 'push-item__border': !!item.price || item.routes.length > 1 })}>
                    <div className="push-item__direction">
                        {!!route.from.icao && <div><span>{route.from.icao}</span> {route.from.title}</div>}
                        {!!route.to.icao && <div><span>{route.to.icao}</span> {route.to.title}</div>}
                    </div>
                    <div className="push-item__row">
                        <div className="push-item__info">
                            <span>{__('menu.list.requestType')}</span>
                            {route.type}
                        </div>
                        {!!route.date && <div className="push-item__info">
                            <span>{__('menu.list.departure')}</span>
                            {route.date}
                            {!!route.time && ` (${route.time})`}
                        </div>}
                        {!!route.arriveDate && <div className="push-item__info">
                            <span>{__('menu.list.arrival')}</span>
                            {route.arriveDate}
                            {!!route.arriveTime && ` (${route.arriveTime})`}
                        </div>}
                        {route.passengers > 0 && <div className="push-item__info">
                            <span>{__('beard.seats')}</span>
                            {route.passengers}
                        </div>}
                    </div>
                </div>
            })}
        </div>
    }

    return <div className="push-item">
        {React.createElement((linkHref || linkAction) ? 'a' : 'div', (linkHref || linkAction) ? {
            href: linkHref,
            onClick: linkAction,
        } : {}, linkItemBlock())}

        {!!item.price && <div className="push-item__price">{item.price}</div>}
        {!!item.text && <div className="push-item__text">{item.text}</div>}
        {!!item.buttons && <div className="push-item__btns">
            {item.buttons.map((button, index) => {
                const type = button.type === 'red' ? 'base' : button.type;
                return <a key={index}
                    className={`button button-${type}`}
                    onClick={e => onActionPress(e, item, button.action)}
                >
                    {button.text}
                </a>
            })}
        </div>}
    </div>
}
